import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { selectSignUpProperty } from '../../../redux/auth/selectors';
import {
  setPropertyConflictResolved as actionSetPropertyConflictResolved,
  setSignUpType as actionSetSignUpType,
} from '../../../redux/auth/actions';

import { setHouseholdMember } from '../../../redux/householdMember/actions';

import { debounce } from 'lodash';

import API from '../../../services/API';
import { TYPE_GENERIC_HOUSEHOLD_INVITE, PROPERTY_SELECT } from '../config';
import { debounceWrapper } from '../../../util/util';

import qmStyles from '../../../theme/qmStyles';
import containerStyles from './HouseholdRequest.scss';

import FormInput from '../../../components/FormInput';
import ContactUs from '../components/ContactUs';
import ToolTip from '../components/ToolTip';
import Button from '../../../components/Button';
import Loader from '../../../components/Loader';

class HouseholdRequest extends Component {
  static propTypes = {
    navigateNext: PropTypes.func.isRequired,
    propertyData: PropTypes.shape({
      address_line1: PropTypes.string.isRequired,
    }).isRequired,
    setPropertyConflictResolved: PropTypes.func.isRequired,
    setSignUpType: PropTypes.func.isRequired,
    setHouseholdMember: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      firstName: '',
      lastName: '',
      email: '',

      error: null,
      errorMessage: '',
    };

    this.postHouseholdCheck = debounce(this.postHouseholdCheck, 1337, {
      leading: true,
      trailing: false,
    });
  }

  setFactory = field => event => {
    this.setState({
      [field]: event.target.value,
    });
  };

  validate = () => {
    const { email, firstName, lastName } = this.state;
    return firstName && lastName && email;
  };

  postHouseholdCheck = e => {
    e.preventDefault();

    if (!this.validate()) return;
    const { email, firstName, lastName } = this.state;
    const {
      propertyData,
      setPropertyConflictResolved,
      navigateNext,
      setSignUpType,
      setHouseholdMember,
    } = this.props;

    const payload = {
      first_name: firstName,
      last_name: lastName,
      email,
      address_line1: propertyData && propertyData.address_line1,
      city: propertyData && propertyData.city,
      province: propertyData && propertyData.province,
      send_request: true,
    };

    this.setState({ loading: true }, () => {
      API.api
        .post('/v2/signup/check_household', payload)
        .then(({ data }) => {
          // on success
          if (data.status < 300) {
            setHouseholdMember({
              firstName: firstName,
              lastName: lastName,
            });
            setSignUpType(TYPE_GENERIC_HOUSEHOLD_INVITE);
            navigateNext().then(setPropertyConflictResolved);
          } else {
            this.setState({
              error: true,
              errorMessage: data.data.message,
            });
          }
          this.setState({ loading: false });
        })
        .catch(err => {
          this.setState({ loading: false });
        });
    });
  };

  renderHeader = () => {
    const { propertyData } = this.props;

    return (
      <>
        <h3 className={containerStyles.title}>
          Enter the details of your household member using Quartermaster to join
          them at {propertyData.address_line1}
        </h3>
      </>
    );
  };

  renderErrorHeader = () => {
    const { errorMessage } = this.state;

    return (
      <>
        <h3 className={containerStyles.title}>Please try again</h3>
        <p className={containerStyles.errorMessage}>
          We couldn't find anyone with that name or email address
        </p>
      </>
    );
  };

  render() {
    const { loading } = this.state;
    const { propertyData } = this.props;

    if (!propertyData) return null;

    const { firstName, lastName, email, error } = this.state;

    return (
      <div className={containerStyles.container}>
        <div className={containerStyles.content}>
          <div className={containerStyles.header}>
            {error ? this.renderErrorHeader() : this.renderHeader()}
          </div>
          <div className={containerStyles.formContainer}>
            <form
              onSubmit={debounceWrapper(this.postHouseholdCheck)}
              style={{ width: '100%' }}
            >
              <div
                className={containerStyles.nameContainer}
                style={{ marginBottom: qmStyles.gutter }}
              >
                <div
                  style={{
                    marginRight: qmStyles.halfGutter,
                  }}
                >
                  <FormInput
                    onChange={this.setFactory('firstName')}
                    label="First Name"
                    value={firstName}
                    style={{
                      border: error ? `1px solid ${qmStyles.qmRed}` : '',
                    }}
                  />
                </div>
                <div>
                  <FormInput
                    onChange={this.setFactory('lastName')}
                    label="Last Name"
                    value={lastName}
                    style={{
                      border: error ? `1px solid ${qmStyles.qmRed}` : '',
                    }}
                  />
                </div>
              </div>
              <FormInput
                onChange={this.setFactory('email')}
                label="Email"
                type="email"
                required
                value={email}
                style={{
                  marginBottom: qmStyles.gutter,
                  border: error ? `1px solid ${qmStyles.qmRed}` : '',
                }}
              />
              <ToolTip />
              {loading ? (
                <div
                  style={{
                    height: 40,
                    backgroundColor: 'white',
                    border: `1px solid ${qmStyles.greyDark}`,
                    width: '100%',
                    marginBottom: qmStyles.gutter,
                  }}
                >
                  <Loader />
                </div>
              ) : (
                <React.Fragment>
                  <FormInput
                    hideBorder
                    type="submit"
                    value={error ? 'Try again' : 'Next'}
                    disabled={!this.validate()}
                    style={{
                      width: '100%',
                      backgroundColor: this.validate()
                        ? qmStyles.qmBabyGreen
                        : qmStyles.qmDisabledGreen,
                      color: 'white',
                      lineHeight: 1.21,
                      marginBottom: qmStyles.gutter,
                    }}
                  />
                  <Button
                    onClick={() => {
                      const { history } = this.props;
                      history.goBack();
                    }}
                    text="Back"
                    style={{
                      marginBottom: qmStyles.gutter,
                      width: 360,
                      border: `1px solid ${qmStyles.qmGreen}`,
                      color: qmStyles.qmGreen,
                    }}
                  />
                </React.Fragment>
              )}
              {error && (
                <Button
                  onClick={() => {
                    const { history } = this.props;
                    history.push(PROPERTY_SELECT);
                  }}
                  text="Start a new property account"
                  style={{ marginBottom: qmStyles.gutter }}
                />
              )}
            </form>
          </div>
          <ContactUs />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  propertyData: selectSignUpProperty(state),
});

const bindAction = {
  setPropertyConflictResolved: actionSetPropertyConflictResolved,
  setSignUpType: actionSetSignUpType,
  setHouseholdMember: setHouseholdMember,
};

export default connect(
  mapStateToProps,
  bindAction,
)(HouseholdRequest);
